export default {
  data() {
    return {
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      columns: [
        {
          fixed: 'left',
          title: '序号',
          width: 60,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '最小值',
          dataIndex: 'minScore',
          disabled: true,
        },
        {
          title: '最大资',
          dataIndex: 'maxScore',
          disabled: true,
        },
        {
          title: '等级',
          dataIndex: 'grade',
          disabled: true,
        },
        {
          title: '风险系数',
          dataIndex: 'risk',
          disabled: true,
        },
        {
          title: '编辑人',
          dataIndex: 'name',
          disabled: true,
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          disabled: true,
        },
        {
          title: '版本',
          dataIndex: 'version',
          disabled: true,
        },
        {
          title: '操作',
          fixed: 'right',
          width: 220,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getPage()
    },
  }
}
